import React from "react";
import arrow from "../assets/images/head3.png";
import img1 from "../assets/images/background-product.jpg";

const Products = () => {
  return (
    <div className="main-div">
      <img src={img1} className="main-img" />
      <div className="div-wrapper">
        <div className="div-wrapper-inner">
          <img src={arrow} className="arrow_img mt ml" />
          <p className="mt">
            Suitable machinery imported from Europe and our unique recipe
            together allows baking the cones with minimal moisture, added
            strength and a longer shelf life. It also helps the cone to remain
            crisp for a long time. The Wafer Biscuit Cones manufactured at Big
            Drum India Pvt Ltd pass through various quality checks to assure
            this!
          </p>

          <div className="div-wrapper-inner1">
            <h4
              style={{ padding: 0, margin: 0, marginTop: "2rem" }}
              className="mt"
            >
              Our Product Range:
            </h4>
            <p>
              <b>Plain Cones –</b> that compliment every flavour of ice cream!
            </p>
            <p>
              <b>Chocolate Cones –</b> to give you the extra oomph of chocolate!
            </p>
            <p>
              <b>Other Colours -</b> You can get creative with more flavours /
              colours of cones that will compliment your perfect ice cream. We
              can together develop it!
            </p>
            <p>
              <b>Natural Top cones –</b> Cones with an open mouth, perfect for
              parlours to fill ice cream
            </p>
            <p>
              <b>Sleeves -</b> Sleeves are the outer cover (packaging), together
              with brand specific printing, which holds the ice cream filled
              into the Wafer Biscuit cone. International standards are followed
              and best quality raw material like foil paper, Poly, Adhesive and
              inks are procured and used in making a sleeve.
            </p>
            <p>
              <b>Regular Sleeves –</b> Length of 165 mm
            </p>
            <p>
              <b>Smaller / Junior Sleeves -</b> Length of 150 mm
            </p>
            <p className="mv">
              *Note Minimum quantity order applies for sleeves
            </p>
          </div>
        </div>
        {/* <Container maxW={"90%"} marginTop={10}>
          <Text fontSize={"lg"} fontWeight={"bold"} color={"#000"}>
            Our Product Range:
          </Text>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Plain Cones –
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              that compliment every flavour of ice cream!
            </Text>
          </Flex>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Chocolate Cones –
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              to give you the extra oomph of chocolate!
            </Text>
          </Flex>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Other Colours -
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              You can get creative with more flavours / colours of cones that
              will compliment your perfect ice cream. We can together develop
              it!
            </Text>
          </Flex>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Natural Top cones –
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              Cones with an open mouth, perfect for parlours to fill ice cream
            </Text>
          </Flex>
          <Flex gap={1.5} marginTop={1} align={"start"}>
            <Text fontSize={"sm"} color={"#000"} fontWeight={"bold"}>
              Sleeves
            </Text>

            <Text fontSize={"sm"} color={"#000"} fontWeight={"bold"}>
              -
            </Text>

            <Text fontSize={"14px"} color={"#000"} flex={1}>
              Sleeves are the outer cover (packaging), together with brand
              specific printing, which holds the ice cream filled into the Wafer
              Biscuit cone. International standards are followed and best
              quality raw material like foil paper, Poly, Adhesive and inks are
              procured and used in making a sleeve.
            </Text>
          </Flex>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Regular Sleeves –
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              Length of 165 mm
            </Text>
          </Flex>
          <Flex mt={1} gap={1.5}>
            <Text fontSize={"sm"} fontWeight={"bold"} color={"#000"}>
              Smaller / Junior Sleeves -
            </Text>
            <Text fontSize={"sm"} color={"#000"}>
              Length of 150 mm
            </Text>
          </Flex>
          <Text
            fontSize={"xs"}
            fontWeight={"bold"}
            color={"#000"}
            marginBlock={5}
          >
            *Note Minimum quantity order applies for sleeves
          </Text>
        </Container> */}
      </div>
    </div>
  );
};

export default Products;
